export default __webpack_public_path__ + "static/media/Emoji_Bar_ThumbsUp.c1581fe5.svg";